import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-packages',
  templateUrl: './packages.component.html'
})
export class PackagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
